import EA from '../helpers/init';

export default EA.Methods.plansCardsEqualHeight = ($this) => {
    const planCardHeaders = $this.querySelectorAll('.plan-card-header');

    function calculateAndSetHeight() {
        // Clear inline height before recalculating
        planCardHeaders.forEach((item) => {
            item.style.minHeight = '';
        });

        // Get max height and set it to all elements
        const maxHeight = Math.max(...[...planCardHeaders].map((item) => item.offsetHeight));
    
        planCardHeaders.forEach((item) => {
            item.style.minHeight = `${maxHeight}px`;
        });
    }

    calculateAndSetHeight();

    // Recalculate on resize
    let resizeTimeoutId;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeoutId);
        resizeTimeoutId = setTimeout(calculateAndSetHeight, 250);
    });
};
